<template>
	<section
		class="w-full py-10 md:-mx-5 md:w-[calc(100%+2.5rem)] md:py-11 lg:mx-0 lg:w-full"
	>
		<header class="flex flex-col gap-2 px-5 pb-6 lg:px-0">
			<Skeleton
				is-active
				variant="white"
				class="h-8 w-4/5 max-w-[430px] md:h-9"
			/>
			<Skeleton is-active variant="white" class="h-7 w-3/5 max-w-[300px]" />
		</header>

		<div class="flex gap-2 overflow-hidden">
			<Skeleton
				v-for="index in 4"
				:key="index"
				is-active
				variant="white"
				class="aspect-[206/318] basis-[44%] shrink-0 first:ml-5 sm:basis-[206px] lg:basis-[calc(33.33333%-5.333px)] lg:first:ml-0 xl:basis-[calc(25%-6px)]"
			/>
		</div>

		<div class="mt-7 flex h-8 items-center justify-end gap-3 px-5 lg:px-0">
			<Skeleton is-active variant="white" class="h-0.5 w-full max-w-[420px]" />
			<Skeleton is-active variant="white" class="size-8" />
			<Skeleton is-active variant="white" class="size-8" />
		</div>
	</section>
</template>
